var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPrinter = function SvgPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 14.667V7.333c0-1.012.822-1.833 1.834-1.833h14.666c1.012 0 1.834.821 1.834 1.833v7.334",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 31.167H9.667A3.666 3.666 0 0 1 6 27.5v-9.166a3.666 3.666 0 0 1 3.667-3.667h25.666A3.666 3.666 0 0 1 39 18.334V27.5a3.666 3.666 0 0 1-3.667 3.667h-3.666",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 25.3h18.334v11.366a1.834 1.834 0 0 1-1.834 1.834H15.167a1.834 1.834 0 0 1-1.834-1.834V25.3ZM13.333 20.167h1.834",
    stroke: "currentColor",
    strokeWidth: 2.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgPrinter;